import { NudosGenericModal } from '../../../../../components/NudosComponents';
import ProductDetailModalContent from '../ProductDetailModalContent/ProductDetailModalContent';
import { ICountryDetail } from 'types/countries';

const ProductDetailModal = ({
  productIdSelected,
  isOpen,
  onClose,
  listOfCountries,
  refreshToolsListing
}: IProductDetailModalProps) => {
  if (!isOpen) return null;

  return (
    <NudosGenericModal
      modalContent={
        <ProductDetailModalContent
          onClose={onClose}
          productIdSelected={productIdSelected}
          listOfCountries={listOfCountries}
          refreshToolsListing={refreshToolsListing}
        />
      }
      closesOnClickOutside={false}
      closeModalCallback={onClose}
    />
  );
};

interface IProductDetailModalProps {
  productIdSelected: number;
  isOpen: boolean;
  onClose: () => void;
  listOfCountries: ICountryDetail[];
  refreshToolsListing: () => void;
}

export default ProductDetailModal;
